var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNti(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "533px",
    height: "329px",
    viewBox: "0 0 533 329",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logo-NTI") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo-NTI",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "NTI_Logo_ASI",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.5,81.5 L96.3,81.5 C119.5,81.5 131.5,90 131.5,114 C152.4,92.7 174.4,77.6 207.7,77.6 C238.6,77.6 262.6,98.9 251.4,148.4 L219.7,285.7 L157.8,285.7 C141.9,285.7 135.8,278 141.6,253.6 L161.7,165.8 C164.8,151.5 161.3,144.5 145.5,144.5 C139.3,144.5 133.1,146 126.6,149.1 L95.7,285.6 L9.5,285.6 L56.5,81.5 Z",
    id: "Path",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.7,217.6 L288,134.1 L268.7,134.1 L280.7,81.5 L300,81.5 L311.2,32 L397.4,32 L385.8,81.5 L417.1,81.5 L405.1,134.1 L373.4,134.1 L355.6,212.2 C351.7,229.2 356,236.2 372.6,236.2 L382.3,236.2 L371.5,284.2 C362.2,287.3 348.7,290 329.7,290 C284.2,290 256,272.9 268.7,217.6",
    id: "Path",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.2,81.5 L489.3,81.5 C516.8,81.5 524.1,88.8 516.4,122.1 L479.3,285.7 L393.1,285.7 L440.2,81.5 Z M447.6,40.9 C447.6,16.5 466.2,0.7 492.8,0.7 C516.8,0.7 532.6,13.5 532.6,33.6 C532.6,57.6 513.3,73 487,73 C463.4,73 447.6,60.6 447.6,40.9",
    id: "Shape",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.4,303.5 L342,303.6 L336.1,328.3 L349.9,328.3 C365.8,328.3 364.5,328.5 365.9,323.5 L370.4,303.5 Z",
    id: "Path",
    fill: "#008445"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.6,303.5 L377.2,303.6 L371.3,328.3 L385.1,328.3 C401,328.3 399.7,328.5 401.1,323.5 L405.6,303.5 Z",
    id: "Path",
    fill: "#FFCE08"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.4,303.5 L412,303.6 L406.1,328.3 L419.9,328.3 C435.8,328.3 434.5,328.5 435.9,323.5 L440.4,303.5 Z",
    id: "Path",
    fill: "#E3592A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.2,303.6 L446.8,303.7 L440.9,328.4 L454.7,328.4 C470.6,328.4 469.3,328.6 470.7,323.6 L475.2,303.6 Z",
    id: "Path",
    fill: "#00B8B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.2,303.5 L5.7,303.6 L0.1,328.3 L314.8,328.2 C330.3,328.3 329.1,328.8 330.7,323.6 L335.2,303.5 Z",
    id: "Path",
    fill: "#231F20"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNti);
export default __webpack_public_path__ + "static/media/nti.b10bfb955ad72a1e01efe9aa6dfdf825.svg";
export { ForwardRef as ReactComponent };